import { api } from '../api/client';
import { translate } from '../i18n/i18n';

export type Learner = {
  id: string;
  name: string;
  consentAt: string | null;
};

export const CONSENT_TEXT =
  'I am this learner\'s parent or carer, or I am responsible for them and have their parent\'s or carer\'s '
  + 'agreement. I give consent for EasyLearning to keep a record of their practice, knowing it can show '
  + 'that they have special educational needs.';

export async function fetchLearners(): Promise<Learner[]> {
  return api<Learner[]>('/learners', { token: true });
}

export async function createLearner(name: string): Promise<Learner> {
  return api<Learner>('/learners', { method: 'POST', token: true, body: { name, consent: true } });
}

export async function giveConsent(id: string): Promise<Learner> {
  return api<Learner>(`/learners/${id}/consent`, { method: 'POST', token: true });
}

export async function renameLearner(id: string, name: string): Promise<Learner> {
  return api<Learner>(`/learners/${id}`, { method: 'PUT', token: true, body: { name } });
}

export async function removeLearner(id: string): Promise<void> {
  await api<void>(`/learners/${id}`, { method: 'DELETE', token: true });
}

const KEY = 'easylearning.currentLearner';

export function rememberLearner(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    return;
  }
}

export function rememberedLearner(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function describeCap(maxLearners: number): string {
  return maxLearners === 1 ? translate('1 learner') : translate('up to {n} learners', { n: maxLearners });
}
